import React, { useEffect, useRef } from 'react'
import Text from 'UIKit/Text'
import { Trans } from 'react-i18next'
import { useAppDispatch, useAppSelector } from 'state'
import Box from 'UIKit/Box/Box'
import { updatePopularSearchGames } from 'state/app/actions'
import SectionTitle from 'views/Home/components/SectionTitle'
import GameService from 'services/GameService'
import { StyledContainerGameCollection, StyledGameBannerItem, StyledGridGame } from 'views/Home/components/styles'
import GameItemLoader from 'views/Games/components/GameItemLoader'
import { emptyArray } from 'utils'

const PopularSearch = () => {
  const dispatch = useAppDispatch()
  const games = useAppSelector((state) => state.app.popularSearchGames)
  const containerRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    const fetch = async () => {
      const collections = await GameService.getGameCollections(0, 1).call()
      const collectionDetails = await GameService.getGameCollectionDetail(collections.data.items[0].code).call()
      dispatch(updatePopularSearchGames({ games: collectionDetails.data.items }))
    }

    if (!games || !games.length) fetch()
  }, [games])

  const gameDisplays = games?.length ? games : emptyArray(10)

  return (
    <Box id="popularsearch" padding={['0px 12px', '', '0px']} mt="24px">
      <SectionTitle
        scrollRef={games && containerRef}
        title={
          <Text small bold color="textSubtle">
            <Trans>Popular search</Trans>
          </Text>
        }
      />
      <StyledContainerGameCollection
        col={[2, 3, 4, 4, 5]}
        gap={[4, 6, 8, 8, 10]}
        row={1}
        itemCount={games?.length || 10}
      >
        <StyledGridGame ref={containerRef}>
          {gameDisplays.map((game, index) => {
            return game ? (
              <Box id="item-select" key={`popular-search-${game.code}`}>
                <StyledGameBannerItem game={game} />
              </Box>
            ) : (
              <Box key={`game-loader-${index}`}>
                <GameItemLoader />
              </Box>
            )
          })}
        </StyledGridGame>
      </StyledContainerGameCollection>
    </Box>
  )
}

export default React.memo(PopularSearch)
